/** A hit from `GET /search?q=`; the API returns entity summaries, we only rely on `id`. */
export interface SearchHit {
  id: string;
  title?: string | null;
  name?: string | null;
  displayName?: string | null;
  humanId?: string | null;
  candidateId?: string | null;
  requestNo?: string | null;
  clientName?: string | null;
  subtitle?: string | null;
  stage?: string | null;
  status?: string | null;
  [key: string]: unknown;
}

export interface SearchResponse {
  positions?: SearchHit[];
  candidates?: SearchHit[];
  submissions?: SearchHit[];
  partners?: SearchHit[];
}

export function searchHitLabel(hit: SearchHit): string {
  return (hit.title ??
    hit.displayName ??
    hit.name ??
    hit.humanId ??
    hit.candidateId ??
    hit.requestNo ??
    hit.id) as string;
}

export function searchHitDetail(hit: SearchHit): string | null {
  const label = searchHitLabel(hit);
  const parts = [
    hit.humanId ?? hit.candidateId ?? hit.requestNo,
    hit.clientName ?? hit.subtitle,
    hit.stage ?? hit.status,
  ]
    .filter((p): p is string => typeof p === 'string' && p.length > 0)
    .filter((p) => p !== label);
  return parts.length ? parts.join(' · ') : null;
}
